import React from "react";
import { motion } from "framer-motion";

export const PageHeader = ({ label, title, subtitle }) => (
  <section className="cfg bg-white pt-32 md:pt-40 pb-10 md:pb-14 border-b border-[#071B2F]/8" data-testid="page-header">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
      {label && (
        <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="cfg-body text-[12px] font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-4">{label}</motion.p>
      )}
      <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 }} className="cfg-display text-4xl md:text-6xl text-[#071B2F] tracking-tight">{title}</motion.h1>
      {subtitle && (
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="cfg-body text-[#071B2F]/55 mt-4 max-w-2xl mx-auto text-base md:text-lg">{subtitle}</motion.p>
      )}
    </div>
  </section>
);
